import { Injectable, signal } from '@angular/core';

/**
 * Centralized app content scroll management.
 * Avoids fragile DOM selectors scattered across feature components.
 */
@Injectable({ providedIn: 'root' })
export class AppScrollService {
  private readonly appContentElement = signal<HTMLElement | null>(null);

  setAppContentElement(element: HTMLElement | null): void {
    this.appContentElement.set(element);
  }

  scrollToTop(behavior: ScrollBehavior = 'auto'): void {
    window.scrollTo({ top: 0, behavior });

    const content = this.appContentElement();
    if (content) {
      content.scrollTo({ top: 0, behavior });
    }
  }
}
